import { render } from "./MaterialBlockedListExport.vue?vue&type=template&id=08bf0772"
import script from "./MaterialBlockedListExport.vue?vue&type=script&lang=js"
export * from "./MaterialBlockedListExport.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__